import { UseQueryResult } from '@tanstack/react-query';

import { useWebsocketQuery } from '@/hooks/query-hooks/websockets';
import { useUser } from '@/hooks/use-user';
import { AgentPresence, userActivityQuery } from '@/queries/gaia-api/user-activity-query';

export const useUserActivity = (): UseQueryResult<AgentPresence[] | null> => {
  const { userId } = useUser();
  return useWebsocketQuery<AgentPresence[] | null, AgentPresence[] | null>(
    userActivityQuery({ userId })
  );
};
